import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { getSetting } from "selectors";
import { Settings } from "constants/settings";
import { setSetting } from "actions";
import Select, { Option } from "components/SearchableSelector/ReactSelect";
import styled from "styled-components/macro";

export const viewTypes = {
  GRID: "Grid View",
  CARD: "Card View",
};
const viewTypeOptions: Option[] = [
  {
    value: viewTypes.GRID,
    label: viewTypes.GRID,
  },
  {
    value: viewTypes.CARD,
    label: viewTypes.CARD,
  },
];
const MinWidthSelect = styled(Select)`
  min-width: 200px;
  margin: 12px;
`;

export const ViewSelector = (): React.JSX.Element => {
  const currentView =
    useSelector(getSetting(Settings.dashboardView)) || viewTypes.CARD;

  const dispatch = useDispatch();
  const handleChangeCurrentView = (newView: Option) => {
    dispatch(setSetting(Settings.dashboardView, newView.value));
  };

  return (
    <MinWidthSelect
      options={viewTypeOptions}
      value={viewTypeOptions.find(option => option.value === currentView)}
      onChange={handleChangeCurrentView}
    />
  );
};
